var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { BaseBlock, broadcastBlockLoad } from "sb-resp-block-lib";
import { BaseDict } from "./dict";
import { config } from "./config";
import { HeaderRegulationRibbonMessageBlock } from "./HeaderRegulationRibbonMessageBlock";
import { HeaderRegulationRibbonMessageBlockData } from "./data";
var _localMocks;
var _libMocks;
if (process.env.NODE_ENV === "development") {
    _libMocks = require("sb-msg-bus/lib-esm/mock");
    _localMocks = require("../../mocks");
}
var HeaderRegulationRibbonMessageBlockRoot = /** @class */ (function (_super) {
    __extends(HeaderRegulationRibbonMessageBlockRoot, _super);
    // constructor sets defaults
    function HeaderRegulationRibbonMessageBlockRoot(domId, options) {
        if (options === void 0) { options = {
            dict: BaseDict,
            cms: {},
            navHandler: {},
            dataProvider: {},
            betSlipUtil: {},
            oddsUtil: {},
            facade: {}
        }; }
        var _this = _super.call(this, domId, options) || this;
        if (process.env.NODE_ENV === "development") {
            // setup data mocks for debug build
            _this.dataProvider = new HeaderRegulationRibbonMessageBlockData({
                eventsManager: _localMocks.EventsManagerMock,
                messageBusProvider: new _libMocks.SBMsgBusMock()
            });
            // setup dictionary for debug build
            _this.options.dict = BaseDict;
            _this.options.cms = _localMocks.CmsMock;
            //export data store to window for debug purposes
            window["HeaderRegulationRibbonMessageBlockDATA"] = _this.dataProvider;
        }
        if (process.env.NODE_ENV === "production" && typeof options.dataProvider !== "undefined") {
            // use pagemethods passed during the construction from the
            // mobile application
            _this.dataProvider = new HeaderRegulationRibbonMessageBlockData(options.dataProvider);
        }
        // if no provided dictionary is not full fill in the missing keys with the base one
        _this.options.dict = __assign({}, BaseDict, (options.dict || {}));
        // merge default and CMS options
        _this.options.cms = __assign({}, config, (options.cms || {}));
        return _this;
    }
    HeaderRegulationRibbonMessageBlockRoot.prototype.activate = function () {
        return _super.prototype.activate.call(this, React.createElement(HeaderRegulationRibbonMessageBlock, { dataProvider: this.dataProvider, dict: this.options.dict, cms: this.options.cms }));
    };
    return HeaderRegulationRibbonMessageBlockRoot;
}(BaseBlock));
export { HeaderRegulationRibbonMessageBlockRoot };
window["HeaderRegulationRibbonMessageBlock"] = HeaderRegulationRibbonMessageBlockRoot;
broadcastBlockLoad("HeaderRegulationRibbonMessageBlock");
//# sourceMappingURL=index.js.map